import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/firma/importer/firmaImporterActions';

export default importerReducers(actions);
